/* Prevous GTM ID */
loadGTMScript('GTM-5MDL82HK');
/* Header Contact Banner */
CMMBanner.make(
  [
    {
      text: [
        {
          content: 'Proudly serving Richardson, TX and the surrounding areas',
        },
      ],
    },
    {
      text: CMMBanner.createSimpleButtons([
        CMMBanner.Button.Presets.DIRECTIONS({
          link: 'http://www.google.com/maps/search/?api=1&query=Smartlooks+Window+%26+Wall+Decor+101+S+Greenville+Ave+%2CRichardson%2CTX+75081-6052',
        }),
        CMMBanner.Button.Presets.PHONE({
          link: 'tel:+19726991151',
        }),
      ]),
    },
  ],
  {
    presets: [CMMBanner.Presets.HEADER_CONTACT],
  },
);
/* Site-Wide Banner */
deferJQuery(function () {
  headerBannerMultipleColumns(
    [
      {
        text: "<a href='more-products-services/products/custom-drapery-hardware-and-fabrics'>Curtains & Valances</a>, <a href='more-products-services/products/wallpaper'>Wallpaper</a> & <a href='more-products-services/services/blind-and-shutter-repairs'>Blind and Shade Repairs</a>.",
        bgColor: '',
        txtColor: '#fff',
        linkColor: '#fff',
        border: '0',
        column_min_width: '50%',
        classname: '',
      },
      {
        text: "<h2>Request a Consultation <div class='cmm-button-group'><a class='cmm-button cmm-button-hd-colors' href='tel:+19726991151'>(972) 699-1151</a><a target='_blank' class='cmm-button cmm-button-white-black' href='http://www.google.com/maps/search/?api=1&query=Smartlooks+Window+%26+Wall+Decor+101+S+Greenville+Ave+%2CRichardson%2CTX+75081-6052'>Directions</a></div></h2><h4>Proudly serving Richardson, Dallas, Plano, McKinney, Allen, Frisco, Garland, Fairview, Lucas, Addison, Carrolton, Rockwall, Sachse, and Heath Texas (TX), and the surrounding areas</h4>",
        bgColor: '#fafafa',
        txtColor: '#000',
        border: '0',
        padding: '1rem',
        classname: '',
      },
    ],
    {
      padding: '1rem 0 0',
      border: {
        border_bottom: '1px solid #ddd',
      },
      column_min_width: '100%',
      classname: 'cmm-header-banner-fullwidth',
    },
  );
  /* Smooth Scrolling */
  cmmSmoothScrollInit();
});

/* Custom Event Tracking */
cmmSetupEventTracking([
  {
    selector: '.cmp-navigation__item a[href="/request-consultation"]',
    action: 'Request Consultation - Menu',
    event: 'click',
  },
]);
/* Site-Wide Footer Blurb */
var txtFooter =
  'We are a local window fashions dealer specializing in the full line of Hunter Douglas window treatments, including roller shades, woven wood shades, roman shades, cellular honeycomb shades, sheers and shadings, vertical blinds, horizontal blinds, plantation shutters, and motorized window coverings. We also offer custom drapery and valances, furniture, patio screen shades, and wallpaper. Our showroom is located in Richardson, Texas, and we proudly serve the Dallas Metroplex and North Dallas areas, including University Park, Plano, Garland, McKinney, Allen, and Frisco, TX.';
footerBlurb(txtFooter);

/* ConvertBoost© */
cmmSetupConvertBoost({
  cta_options: [
    {
      mode: 'modal',
      icon: 'phone',
      icon_size: 'podium',
      color: '#F9903C',
      text: '',
      text_shadow: '2px 2px 2px rgba(0,0,0,.2)',
      devices: ['desktop', 'laptop', 'tablet', 'mobile'],
    },
  ],
  modal_options: {
    header_text:
      '<img style="margin-top:10px;max-width:200px;" src="https://assets.hunterdouglas.com/content/dam/dealer-logos/s/smartlooks-window---wall-decor-10038071/web-10038071.png">',
    header_color: '#ffffff',
    description_text:
      'Ready to transform your space?<br>Our design team is here to help!',
    font: {
      family: 'AUTO',
    },
    buttons: [
      {
        title: '(972) 699-1151',
        link: 'tel:+19726991151',
        txt_color_hover: '#f5842a',
        bg_color: '#f5842a',
        class_list: ['call-us'],
        icon: 'phone',
      },
      {
        title: 'VISIT SHOWROOM',
        link: 'http://www.google.com/maps/search/?api=1&query=Smartlooks+Window+%26+Wall+Decor+101+S+Greenville+Ave+%2CRichardson%2CTX+75081-6052',
        link_target: '_blank',
        txt_color_hover: '#f5842a',
        bg_color: '#f5842a',
        class_list: ['visit-showroom'],
        icon: 'map-pin',
      },
      {
        title: 'REQUEST A CONSULTATION',
        link: '/request-consultation',
        bg_color: '#f5842a',
        txt_color_hover: '#f5842a',
        class_list: ['request-consultation'],
        icon: 'email',
      },
    ],
    footer_text:
      'Smartlooks Window & Wall Decor is a local window fashions dealer specializing in the full line of Hunter Douglas window treatments, and also offers custom drapery and valances, drapery hardware, furniture, patio screen shades, exterior shutters, wallpaper.',
    footer_color: '#0C0C0C',
  },
}).then((_) => {
  /* ConvertBoost©  Event Tracking */
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .call-us',
      action: 'Call (972) 699-1151 - ConvertBoost©',
      event: 'click',
    },
  ]);
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .visit-showroom',
      action: 'Visit Showroom - ConvertBoost©',
      event: 'click',
    },
  ]);
  cmmSetupEventTracking([
    {
      selector: '#cmm-call-to-action-modal .request-consultation',
      action: 'Request a Consultation - ConvertBoost©',
      event: 'click',
    },
  ]);
});

/* Custom Metadata */
cmmUpdateMetadata({
  'hunter-douglas/shades/sheer-shades': {
    t: 'Hunter Douglas Sheer Shades | Smartlooks Window & Wall Decor',
    d: 'Find perfect sheer window shades from Hunter Douglas at Smartlooks Window & Wall Decor near Richardson, McKinney, Allen, and Frisco, Texas.',
  },
  'hunter-douglas/shades/cellular-shades': {
    t: 'Hunter Douglas Cellular Shades | Smartlooks Window & Wall Decor',
    d: 'Upgrade your home with Hunter Douglas Honeycomb Shades at Smartlooks Window & Wall Decor near Richardson, TX.',
  },
  'hunter-douglas/shades/roman-shades': {
    t: 'Hunter Douglas Roman Shades | Smartlooks Window & Wall Decor',
    d: 'Introduce Hunter Douglas Roman Shades to your home with Smartlooks Window & Wall Decor',
  },
  'hunter-douglas/shades/roller-shades': {
    t: 'Hunter Douglas Roller Shades | Smartlooks Window & Wall Decor',
    d: 'Find the perfect roller shades for your home at Smartlooks Window & Wall Decor near Richardson, TX.',
  },
  'hunter-douglas/shades/woven-shades': {
    t: 'Hunter Douglas Woven Shades | Smartlooks Window & Wall Decor',
    d: 'Woven Wood Shades, Bamboo Shades, and Bamboo Blinds from Hunter Douglas at Smartlooks Window & Wall Decor.',
  },
  'hunter-douglas/shades/vertical-shades': {
    t: 'Vertical Shades | Smartlooks Window & Wall Decor',
    d: 'Vertical Shades for Sliding Doors from Hunter Douglas at Smartlooks Window & Wall Decor near Richardson, North Dallas, University Park, Plano, Allen, and Frisco, Texas.',
  },
  'hunter-douglas/shutters': {
    t: 'Hunter Douglas Plantation Shutters | Smartlooks Window & Wall Decor',
    d: 'Introduce elegance and timeless style through our plantation shutters! Hunter Douglas window shutters available at Smartlooks Window & Wall Decor.',
  },
  'hunter-douglas/blinds/vertical-blinds': {
    t: 'Hunter Douglas vertical Blinds | Smartlooks Window & Wall Decor',
    d: 'Premium vertical blinds available at Smartlooks Window & Wall Decor near Richardson, University Park, Plano, Garland, McKinney, Allen, and Frisco, Texas.',
  },
  'hunter-douglas/blinds/wood-blinds': {
    t: 'Hunter Douglas Wood Blinds | Smartlooks Window & Wall Decor',
    d: 'Premium wood window blinds available at Smartlooks Window & Wall Decor near Richardson, North Dallas, Plano, Garland, McKinney, Allen, and Frisco, Texas.',
  },
  'hunter-douglas/blinds/metal-blinds': {
    t: 'Hunter Douglas metal Blinds | Smartlooks Window & Wall Decor',
    d: 'Premium aluminum blinds available at Smartlooks Window & Wall Decor near Richardson, North Dallas, Plano, Garland, McKinney, Allen, and Frisco, Texas.',
  },
  'hunter-douglas/drapery': {
    t: 'Hunter Douglas Drapery | Smartlooks Window & Wall Decor',
    d: 'Drapery, Valance Curtains, and Living Room Curtains from Hunter Douglas at Smartlooks Window & Wall Decor near Sacramento, Folsom, El Dorado Hills, California.',
  },
  'hunter-douglas/powerview-automation': {
    t: 'Motorized Blinds, Automatic Blinds | Smartlooks Window & Wall Decor',
    d: 'Modernize your home with motorized blinds. Raise and lower the with press of a button or voice command.',
  },
  'hunter-douglas/featured/room-darkening': {
    t: 'Room Darkening | Smartlooks Window & Wall Decor',
    d: 'Find the perfect blackout curtains and shades for your home! Check out more at Smartlooks Window & Wall Decor',
  },
  'hunter-douglas/featured/energy-efficient': {
    t: 'Energy Efficiency | Smartlooks Window & Wall Decor',
    d: 'Create a more energy efficiency home with Smartlooks Window & Wall Decor. Our products can help your home and lower your bill.',
  },
  'hunter-douglas/featured/light-enhancing': {
    t: 'Light Enhancing | Smartlooks Window & Wall Decor',
    d: 'Perfectly control the light in your home. Using products from Hunter Douglas and Smartlooks Window & Wall Decor',
  },
  'hunter-douglas/featured/door-coverings': {
    t: 'Door Covering | Smartlooks Window & Wall Decor',
    d: 'Find the ideal door cover with Hunter Douglas! Products available at Smartlooks Window & Wall Decor',
  },
  'hunter-douglas/featured/sound-absorption': {
    t: 'Sound Absorption | Smartlooks Window & Wall Decor',
    d: 'Increase comfort in your home through our sound absorbent drapes and shades. ',
  },
  'hunter-douglas/featured/top-down-bottom-up-shades': {
    t: 'Top-Down, Bottom-Up | Smartlooks Window & Wall Decor',
    d: 'Perfect the privacy and light control in your home.',
  },
});
